import { dataProps, 
        itemListProps,
        paymentTermListProps } from './properties'

export const setInventoryInvoiceList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
if(!state.nav.had_results) {
   state.nav.had_results = payload.total>0
}
}    

export const setInventoryInvoiceOutstandingList = (state, payload) => {
    state.outstanding_list = payload
}

export const resetInventoryInvoiceOutstandingList = state => {
    state.outstanding_list = []
}

export const setInventoryInvoiceData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    } else if(payload.copy) {
        state.props.item_list.forEach(element => {
            element.id = 0
        })
    }
    
    let key = 0
    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

} 

export const setPurchaseOrderShippingAddress = (state, payload) => {
    state.props.shipment_address 
        = payload.legal_name+'\r\n'+payload.address+', \r\n'+payload.city_name+'-'+payload.postal_code+', '
                +payload.province_name+', '+payload.country_name+'.\r\n'
                +payload.contact_number+', '+payload.email_address+'.'
}

export const addPurchaseInvoiceItems_Bulk = (state, payload) => {

    payload.forEach(element => {

        let unit_rate = parseFloat(element.unit_rate)
        let qty = parseFloat(element.qty)
        let sub_total = (unit_rate*qty)
        let tax_percent = parseFloat(element.tax_percent)
        let tax_amount = (sub_total*(tax_percent/100))
        let net_total = (sub_total+tax_amount)

        state.props.item_list.push({
            key: 0,
            id: 0,
            item_id: element.id,
            item_detail: {id: element.id, sku_code: element.sku_code, article_name: element.article_name, unit_name: element.unit_name},
            description: '',
            qty: qty,
            unit_rate: unit_rate,
            sub_total: sub_total,
            tax_percent: tax_percent,
            tax_amount: tax_amount,
            net_total: net_total,
            item_edit: 1
        })

        key ++
    })

    let key = 0
    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const addNewInventoryInvoiceItemListRow = state => {

    let key = 0
    state.props.item_list.push(JSON.parse(JSON.stringify(itemListProps)))

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('item_id_'+(key-1)).focus()
    }, 300);

}

export const removeInventoryInvoiceItemListRow = (state, payload) => {

    let key = 0

    state.props.item_list.splice(payload, 1)

    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    }

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const addNewInventoryInvoicePaymentTermListRow = state => {

    let key = 0
    state.props.payment_term.push(JSON.parse(JSON.stringify(paymentTermListProps)))

    state.props.payment_term.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('payment_term_date_'+(key-1)).focus()
    }, 300);

}

export const removeInventoryInvoicePaymentTermListRow = (state, payload) => {

    let key = 0

    state.props.payment_term.splice(payload, 1)

    if(state.props.payment_term.length === 0) {
        state.props.payment_term = [JSON.parse(JSON.stringify(paymentTermListProps))]
    }

    state.props.payment_term.forEach(element => {
        element.key = key
        key ++
    })

}

export const setInventoryInvoiceExchangeRate = (state, payload) => {
    state.props.exchange_rate = payload
}

export const resetInventoryInvoiceData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryInvoice/mutations.js